import React from 'react';
import PropTypes from 'prop-types';

/**
 * RecentActivity - List of recent form submissions
 *
 * @param {Object} props
 * @param {Array} props.recentForms - Array of recent form submissions
 * @param {Function} props.onNavigate - Navigation handler
 */
const RecentActivity = ({ recentForms, onNavigate }) => {
  return (
    <div className="recent-activity-section">
      <h2>Recent Form Submissions</h2>
      <div className="activity-list">
        {recentForms && recentForms.length > 0 ? (
          recentForms.slice(0, 5).map((form, index) => (
            <div key={form.id || index} className="activity-item">
              <div className="activity-icon">📝</div>
              <div className="activity-content">
                <div className="activity-title">
                  {form.formName || form.formType || 'Form Submission'}
                </div>
                <div className="activity-meta">
                  Submitted by {form.portalUser?.userName || 'Unknown'} •
                  {new Date(
                    form.created || form.submittedDate
                  ).toLocaleDateString()}
                </div>
              </div>
              <button
                className="btn-view-small"
                onClick={() => onNavigate('forms')}
              >
                View
              </button>
            </div>
          ))
        ) : (
          <div className="activity-empty">
            <p>No recent form submissions to display.</p>
            <button
              className="btn-action"
              onClick={() => onNavigate('forms')}
              style={{ marginTop: '12px' }}
            >
              Browse All Forms
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

RecentActivity.propTypes = {
  recentForms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      formName: PropTypes.string,
      formType: PropTypes.string,
      created: PropTypes.string,
      submittedDate: PropTypes.string,
      portalUser: PropTypes.shape({
        userName: PropTypes.string,
      }),
    })
  ),
  onNavigate: PropTypes.func.isRequired,
};

RecentActivity.defaultProps = {
  recentForms: [],
};

export default RecentActivity;
